module.exports = __webpack_public_path__ + "img/shiernian.7581a027.jpeg";